import { FunnelChartDataQuery } from "@/__generated__/types";
import {
  FunnelMapKeys,
  getGroupNames,
  groupStatesByFunnelGroup,
  translateGroupName,
} from "@/util/funnelGroups";

export interface ProcessedChartData {
  funnelStep: string;
  groupName: FunnelMapKeys<"COMMUNITY_ADOPTION_CHART">;
  inCommunity: number;
  notInCommunity: number;
}

export const processChartData = (
  data?: FunnelChartDataQuery,
): ProcessedChartData[] | undefined => {
  const chartColumns = getGroupNames("COMMUNITY_ADOPTION_CHART");

  if (data?.node?.__typename === "Organization") {
    const inCommunity = groupStatesByFunnelGroup(
      data?.node?.funnelChartData?.inCommunity || [],
      "COMMUNITY_ADOPTION_CHART",
    );

    const notInCommunity = groupStatesByFunnelGroup(
      data?.node?.funnelChartData?.notInCommunity || [],
      "COMMUNITY_ADOPTION_CHART",
    );

    return chartColumns.map((colName) => {
      const inCommunityCount = inCommunity[colName] || 0;
      const notInCommunityCount = notInCommunity[colName] || 0;

      const total = inCommunityCount + notInCommunityCount;
      return {
        funnelStep: translateGroupName(colName),
        groupName: colName,
        inCommunityCount: inCommunityCount,
        notInCommunityCount: notInCommunityCount,
        inCommunity:
          total > 0 ? Math.round((inCommunityCount / total) * 100) : 0,
        notInCommunity:
          total > 0 ? Math.round((notInCommunityCount / total) * 100) : 0,
      };
    });
  }
};
